// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/policy/mondoo_policy.actions.go

export const PROCESS_CASE_EVENTS =
  "mondoo.policy.ExtendedHub.ProcessCaseEvents";
